import { useEffect, useMemo, useState, Fragment } from 'react';
import { useTheme, Tab, Tabs, Tooltip } from '@mui/material';
import { PageLayout } from '../../PageLayout';
import { DEFAULT_TAB_SX_STYLES } from '../../../utils/styleHelpers';
import { TabPanel } from '../../Atoms/TabPanel';
import { fetchRuns } from '../../../store/Run';
import { CalculatedRunTab } from './CalculatedRunTab';
import { DatePastRunTab } from './DatePastRunTab';
import { DateFutureRunTab } from './DateFutureRunTab';

export const RunPage = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = useMemo(
    () => [
      {
        name: 'Calculated',
        tooltip: 'View calculated runs.',
        component: CalculatedRunTab
      },
      {
        name: 'Date Only, Past',
        tooltip: 'View date only past runs.',
        component: DatePastRunTab
      },
      {
        name: 'Date Only, Future',
        tooltip: 'View date only future runs.',
        component: DateFutureRunTab
      }
    ],
    []
  );

  useEffect(() => {
    fetchRuns();
  }, []);

  return (
    <PageLayout
      className="w-full mt-0"
      dataTestId="run-page"
      dataCy="run-page-card"
      pageTitle="">
      <Fragment>
        <Tabs
          sx={DEFAULT_TAB_SX_STYLES}
          value={selectedTab}
          scrollButtons="auto"
          onChange={(_e, index) => {
            setSelectedTab(index);
          }}
          slotProps={{
            indicator: {
              sx: {
                backgroundColor: theme.palette.primary.main,
                height: 2,
                borderRadius: 1
              }
            }
          }}>
          {tabs.map((tab, _index) => (
            <Tab
              sx={{
                color: 'grey9',
                fontSize: '.8rem',
                textTransform: 'none'
              }}
              key={tab.name}
              label={
                <Tooltip
                  title={<span style={{ whiteSpace: 'pre-line' }}>{tab.tooltip}</span>}
                  slotProps={{
                    tooltip: {
                      sx: {
                        maxWidth: 'none',
                        width: 'auto'
                      }
                    }
                  }}>
                  <span>{tab.name}</span>
                </Tooltip>
              }
            />
          ))}
        </Tabs>
      </Fragment>
      {tabs.map((tab, index) => (
        <TabPanel
          key={tab.name}
          value={selectedTab}
          index={index}>
          <tab.component />
        </TabPanel>
      ))}
    </PageLayout>
  );
};
